export function getDateColumnOptions(field) {
    return {
        type: 'date',
        valueGetter: (value, row) => {
            const rawValue = row.beleg[field.toLowerCase()];
            if (rawValue == null || rawValue === '') return null;

            const date = new Date(rawValue);
            if (Number.isNaN(date.getTime())) return null;

            // .NET uses DateTime.MinValue for an unset date.
            if (date.getFullYear() === 1 && date.getMonth() === 0 && date.getDate() === 1) return null;

            return date;
        },
        valueFormatter: (value) => value == null ? '' : value.toLocaleDateString('de-DE', {
            year: 'numeric', month: '2-digit', day: '2-digit'
        })
    };
}
